import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Initialize network logging
import './lib/utils/networkLogger';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('PrivyBudget: SW registration successful with scope: ', registration.scope);
      })
      .catch((error) => {
        console.log('PrivyBudget: SW registration failed: ', error);
      });
  });
}